import './Loader.css';

interface LoaderProps {
  size?: number;
  reverse?: boolean;
  label?: string;
  className?: string;
}

export default function Loader({
  size = 160,
  reverse = false,
  label = 'Loading',
  className,
}: LoaderProps) {
  const classes = [
    'cz-loader',
    reverse ? 'cz-loader--reverse' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <svg
      className={classes}
      width={size}
      height={size}
      viewBox="0 0 200 200"
      role="img"
      aria-label={label}
    >
      <path
        className="cz-loader__ring"
        d="M 163.444 70.413 A 70 70 0 1 0 163.444 129.587"
      />
      <circle className="cz-loader__dot" cx="118" cy="100" r="13" />
    </svg>
  );
}
